/**
 * Resolves the deployed application stage for asset/API host selection.
 *
 * Prefer REACT_APP_STAGE, then REACT_APP_ENV. Comparisons against
 * process.env.REACT_APP_* are written as direct equality so CRA/webpack
 * can constant-fold production builds and drop staging host literals.
 */

export type AppStage = "staging" | "production";

export const getAppStage = (): AppStage => {
  // Direct env equality — required for production bundle DCE.
  if (
    process.env.REACT_APP_STAGE === "production" ||
    process.env.REACT_APP_ENV === "production"
  ) {
    return "production";
  }
  if (
    process.env.REACT_APP_STAGE === "staging" ||
    process.env.REACT_APP_ENV === "staging"
  ) {
    return "staging";
  }

  // Development / localhost only (stripped from production builds).
  if (process.env.REACT_APP_ENV === "development") {
    if (typeof window !== "undefined") {
      const host = window.location.hostname.toLowerCase();
      if (host === "localhost" || host === "127.0.0.1") return "staging";
    }
    return "staging";
  }

  // Fail closed: never invent staging for an unknown production-like build.
  return "production";
};
